/* Platoria star ratings for collection product cards.
 * Shows Platoria (Amazon/Google) ratings when available; the theme's
 * server-rendered Judge.me stars remain as the instant fallback.
 * Performance: only fetches for cards near the viewport, caches results
 * in localStorage for 12h, and limits concurrent requests to 4.
 */
(function () {
  'use strict';
  if (window.__platoriaCardRating) return;
  window.__platoriaCardRating = true;

  var API = 'https://ecomm.platoria.com/shop/shopify-product-platoria-rating/shopify-product-id/';
  var CACHE_PREFIX = 'ptcr:';
  var CACHE_TTL = 12 * 60 * 60 * 1000;
  var MAX_CONCURRENT = 4;

  var queue = [];
  var active = 0;
  var failed = {};

  function cacheGet(id) {
    try {
      var raw = localStorage.getItem(CACHE_PREFIX + id);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.t > CACHE_TTL) {
        localStorage.removeItem(CACHE_PREFIX + id);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(id, rating, count) {
    try {
      localStorage.setItem(CACHE_PREFIX + id, JSON.stringify({ r: rating, c: count, t: Date.now() }));
    } catch (e) {
      /* storage unavailable or full - ignore */
    }
  }

  /* Same rounding rule as the theme's snippets/rating.liquid */
  function roundRating(value) {
    var whole = Math.floor(value);
    var decimal = value - whole;
    if (decimal >= 0.3 && decimal <= 0.7) return whole + 0.5;
    if (decimal > 0.7) return Math.ceil(value);
    return whole;
  }

  function render(el, rating, count) {
    if (!rating || !count) return;
    var stars = roundRating(rating);
    var label = rating.toFixed(1) + ' out of 5 stars, ' + count.toLocaleString() + ' reviews';
    el.innerHTML =
      '<div class="rating inline-block align-middle" role="img" aria-label="' + label + '">' +
        '<span class="rating__stars" aria-hidden="true" style="--rating: ' + stars + '; --rating-max: 5;">★★★★★</span>' +
      '</div>' +
      '<div class="rating__count inline-block align-middle text-sm">(' + count.toLocaleString() + ')</div>';
  }

  function processNext() {
    if (active >= MAX_CONCURRENT || queue.length === 0) return;
    var el = queue.shift();
    var id = el.getAttribute('data-product-id');
    if (!id || failed[id]) {
      processNext();
      return;
    }

    var cached = cacheGet(id);
    if (cached) {
      render(el, cached.r, cached.c);
      processNext();
      return;
    }

    active++;
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = controller && setTimeout(function () { controller.abort(); }, 6000);

    fetch(API + id, controller ? { signal: controller.signal } : undefined)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var rating = (data && data.rating) || 0;
        var count = (data && data.reviewCount) || 0;
        cacheSet(id, rating, count); /* cache zero results too, avoids refetching */
        render(el, rating, count);
      })
      .catch(function () {
        failed[id] = true;
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
        active--;
        processNext();
      });

    processNext();
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          queue.push(entry.target);
          processNext();
        });
      }, { rootMargin: '300px 0px' })
    : null;

  function scan() {
    var els = document.querySelectorAll('[data-platoria-rating]:not([data-ptcr])');
    els.forEach(function (el) {
      el.setAttribute('data-ptcr', '');
      if (observer) {
        observer.observe(el);
      } else {
        queue.push(el);
        processNext();
      }
    });
  }

  /* Pick up cards added by AJAX pagination, infinite scroll and filtering */
  var scanScheduled = false;
  var mo = new MutationObserver(function () {
    if (scanScheduled) return;
    scanScheduled = true;
    setTimeout(function () {
      scanScheduled = false;
      scan();
    }, 150);
  });

  function init() {
    scan();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
